import React from 'react'
import { ErrorDescription, ErrorTitle, ImageContainer } from './styles'
import { Images } from '~/assets/images'
import { ForbiddenError, NotFoundError, UnexpectedError } from '~/protocols/http'
import { message } from '~/services'

const MessageError = ({ title, description }: { title: string; description: string }): JSX.Element => (
  <ImageContainer>
    <Images.searchNotFound />
    <ErrorTitle>{title}</ErrorTitle>
    <ErrorDescription>{description}</ErrorDescription>
  </ImageContainer>
)

interface SearchErrorProps {
  error?: string | boolean | NotFoundError | UnexpectedError | ForbiddenError | Error
}

export const SearchError = ({ error }: SearchErrorProps): JSX.Element => {
  if (error instanceof NotFoundError) {
    return <MessageError title={message('patient.not_found_title')} description={message('patient.not_found')} />
  }

  if (error instanceof UnexpectedError) {
    return (
      <MessageError
        title={message('patient.unexpected_error_title')}
        description={message('patient.unexpected_error')}
      />
    )
  }

  if (error instanceof ForbiddenError) {
    return <MessageError title={message('patient.forbidden_title')} description={message('patient.forbidden')} />
  }

  if (error instanceof Error) {
    return <MessageError title={message('patient.unexpected_error_title')} description={error.message} />
  }

  if (typeof error === 'string') {
    return <MessageError title={message('patient.unexpected_error_title')} description={error} />
  }

  return <></>
}
